module.exports = __webpack_public_path__ + "static/media/talk-dark-logo.e1e47beb.png";